import { Route } from "react-router-dom";
import Store from "../pages/store/store";
import Checkout from "../pages/store/checkout";
import Admin from "../pages/store/admin";
import Login from "../pages/store/login";

const StoreRoutes = [
    <Route path="/store/t-shirts" element={<Store />}/>,
    <Route path="/store/checkout/:id" element={<Checkout />}/>,
    <Route path="/store/login" element={<Login />}/>,
    <Route path="/store/admin" element={<Admin />}/>
]
    
export default StoreRoutes;
